
console.log("custom-extras.js loaded - in the bottom of theme.liquid");


// SINGLE PRODUCT TEMPLATE - Move Affirm promotional thing from under the product price, to the above the Add To Cart - buttons etc, to make it cleaner and more consistent. We want all our "pay later" options to be in the same place.
document.addEventListener("DOMContentLoaded", function() {
        let attempts = 0;
        const maxAttempts = 40;
        const interval = 200;

        function moveElement() {
            const affirmElement = document.querySelector('.affirm-as-low-as');
            const targetElement = document.querySelector('.custom-liquid-payment-options');

            if (affirmElement && targetElement) {
                //targetElement.parentNode.insertBefore(affirmElement, targetElement);
                //lets add it AFTER ".custom-liquid-payment-options" instead of before .product-detail__form__action
                targetElement.parentNode.insertBefore(affirmElement, targetElement.nextSibling);
                console.log('PAY LATER MOVING: .affirm-as-low-as element moved before .product-detail__form__action');
            } else {
                if (attempts < maxAttempts) {
                    console.log(`PAY LATER MOVING: affirm-as-low-as element not found, retrying in ${interval}ms`);
                    attempts++;
                    setTimeout(moveElement, interval);
                } else {
                    console.log('PAY LATER MOVING: Max attempts reached. .affirm-as-low-as element not found.');
                }
            }
        }

        moveElement();
    });

